<script lang="ts">

    import { deglingos, english, minitel } from '../store/store';
    import { onDestroy } from 'svelte';
    import {
        storeCurRoute,
        idPageCgv,
        idPageComment,
        idPageHome,
        idPageLegal,
        idPageOu,
        idPageProjets,
        idPageQui,
        idPageQuoi,
        nameFRPageCgv,
        nameFRPageComment,
        nameFRPageHome,
        nameFRPageLegal,
        nameFRPageOu,
        nameFRPageProjets,
        nameFRPageQui,
        nameFRPageQuoi,
        nameENPageCgv,
        nameENPageComment,
        nameENPageHome,
        nameENPageLegal,
        nameENPageOu,
        nameENPageProjets,
        nameENPageQui,
        nameENPageQuoi,
    } from './router/router';
    import { redirectTo } from '../js/common';

    let selectedLink: string = idPageHome;
    let isOpenBurger: boolean = false;

    const unsubscribe = storeCurRoute.subscribe(value => {
        if (value.length > 1 && value.charAt(value.length-1) == '/') {
            selectedLink = value.slice(0, value.length-1);
        } else {
            selectedLink = value;
        }
    })

    function burgerToggle(event) {
        if (getComputedStyle(document.getElementById("id_burger")).display != "none") {
            isOpenBurger = !isOpenBurger;
        }
    }

    onDestroy(unsubscribe);

</script>
  
  
<style lang="scss">
    
    .navigation {
        z-index: 100;
        transition: transform .5s;
        position: fixed;
        top: 0px;
        padding: 50px 0 200% 0;
        width: 90%;
        transform: translateX(-800px);
        background-color: $color_primary;
        color: $color_secondary;
        border-radius: 4px;
        &--open {
            transform: translateX(0px);
        }
        &__ul {
            list-style-type: none;
            &__li {
                padding: 0 0 12px 0;
            }
        }
        &__minitel {
            background-color: $color_black;
            color: $color_minitel_green;
        }
    }

    /* burger */

    $burger_size_a: 7px;
    $burger_size_b: 2px;
    $burger_size_V: 34px;
    $burger_size_c: 9px;
    $burger_size_d: 16px;
    $burger_size_H: 34px;
    $burger_size_top_tY: 9px;
    $burger_size_bottom_tY: -9px;

    .burger {
        position: fixed;
        top: 20px;
        left: 20px;
        height: $burger_size_H;
        width: $burger_size_V;
        border-radius: 50%;
        border: $burger_size_b solid $color_secondary;
        cursor: pointer;
        z-index: 1000;
        &__minitel {
            border: $burger_size_b solid $color_minitel_green;
        }
        &__lineTop, &__lineMiddle, &__lineBottom {
            height: $burger_size_b;
            width: $burger_size_d;
            margin: $burger_size_a $burger_size_c;
            background-color: $color_secondary;
            transition: 0.4s;
            &__minitel {
                background-color: $color_minitel_green;
            }
        }
        &__lineTop--open {
            height: $burger_size_b;
            width: $burger_size_d;
            margin: $burger_size_a $burger_size_c;
            background-color: $color_secondary;
            transition: 0.4s;
            transform: translateY($burger_size_top_tY) rotate(-45deg);    
            &__minitel {
                background-color: $color_minitel_green;
            }
        }
        &__lineMiddle--open {
            height: $burger_size_b;
            width: $burger_size_d;
            margin: $burger_size_a $burger_size_c;
            background-color: $color_secondary;
            transition: 0.4s;
            opacity: 0;
            &__minitel {
                background-color: $color_minitel_green;
            }
        }
        &__lineBottom--open {
            height: $burger_size_b;
            width: $burger_size_d;
            margin: $burger_size_a $burger_size_c;
            background-color: $color_secondary;
            transition: 0.4s;
            transform: translateY($burger_size_bottom_tY) rotate(45deg);
            &__minitel {
                background-color: $color_minitel_green;
            }
        }
    }

    @include medium {
        .navigation {
            transform: translateX(-1024px);
            &--open {
                transform: translateX(0px);
            }
        }
    }

    @include large {
        .navigation {
            z-index: 100;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            position: initial;
            padding: 0 0 0 0;
            width: 100%;
            max-width: 100%;
            transform: inherit;
            background-color: inherit;
            border-radius: 0px;
            color: $color_primary;
            &__deglingos {
                color: $color_tertiary;
            }
            &__minitel {
                background-color: $color_black;
                color: $color_minitel_green;
            }
            &__ul {
                width: 100%;
                padding: 0;
                display: flex;
                justify-content: space-around;
                flex-direction: row;
                align-items: center;
                &__li {
                    cursor: pointer;
                    padding: 0 0 0 0;
                    display: inline;
                    position: relative;
                    white-space: nowrap;
                    &--active {
                        color: $color_secondary;
                    }
                    &:hover {
                        color: $color_secondary;
                    }
                    &__minitel {
                        &:hover {
                            color: $color_minitel_blue;
                            background-color: $color_white;
                        }
                        &--active {
                            color: $color_minitel_blue;
                            background-color: $color_white;
                        }
                    }
                }
            }
        }

        .burger {
            display: none;
        }

    }

</style>
  
  
{#if $minitel}
<div id="id_burger" class="burger burger__minitel" on:click={burgerToggle}>
    <div class="{isOpenBurger ? 'burger__lineTop--open burger__lineTop--open__minitel' : 'burger__lineTop burger__lineTop__minitel'}"></div>
    <div class="{isOpenBurger ? 'burger__lineMiddle--open burger__lineMiddle--open__minitel' : 'burger__lineMiddle burger__lineMiddle__minitel'}"></div>
    <div class="{isOpenBurger ? 'burger__lineBottom--open burger__lineBottom--open__minitel' : 'burger__lineBottom burger__lineBottom__minitel'}"></div>
</div>
{:else}
<div id="id_burger" class="burger" on:click={burgerToggle}>
    <div class="{isOpenBurger ? 'burger__lineTop--open' : 'burger__lineTop'}"></div>
    <div class="{isOpenBurger ? 'burger__lineMiddle--open' : 'burger__lineMiddle'}"></div>
    <div class="{isOpenBurger ? 'burger__lineBottom--open' : 'burger__lineBottom'}"></div>
</div>
{/if}

<nav class="{isOpenBurger ? 'navigation navigation--open' : 'navigation'}" 
    class:navigation__deglingos={$deglingos}
    class:navigation__minitel={$minitel}
    on:click={burgerToggle}>
    <ul class="navigation__ul">
        <li class="navigation__ul__li"
            class:navigation__ul__li--active={selectedLink === idPageQui && !$minitel}
            class:navigation__ul__li__minitel={$minitel}
            class:navigation__ul__li__minitel--active={selectedLink === idPageQui && $minitel}
            on:click={() => redirectTo(idPageQui)}
            on:keydown={() => redirectTo(idPageQui)}>
            {#if $english}
                {nameENPageQui}
            {:else}
                {nameFRPageQui}
            {/if}
        </li>
        <li class="navigation__ul__li"
            class:navigation__ul__li--active={selectedLink === idPageQuoi && !$minitel}
            class:navigation__ul__li__minitel={$minitel}
            class:navigation__ul__li__minitel--active={selectedLink === idPageQuoi && $minitel}
            on:click={() => redirectTo(idPageQuoi)}
            on:keydown={() => redirectTo(idPageQuoi)}>
            {#if $english}
                {nameENPageQuoi}
            {:else}
                {nameFRPageQuoi}
            {/if}
        </li>
        <li class="navigation__ul__li"
            class:navigation__ul__li--active={selectedLink === idPageComment && !$minitel}
            class:navigation__ul__li__minitel={$minitel}
            class:navigation__ul__li__minitel--active={selectedLink === idPageComment && $minitel}
            on:click={() => redirectTo(idPageComment)}
            on:keydown={() => redirectTo(idPageComment)}>
            {#if $english}
                {nameENPageComment}
            {:else}
                {nameFRPageComment}
            {/if}
        </li>
        <li class="navigation__ul__li"
            class:navigation__ul__li--active={selectedLink === idPageOu && !$minitel}
            class:navigation__ul__li__minitel={$minitel}
            class:navigation__ul__li__minitel--active={selectedLink === idPageOu && $minitel}
            on:click={() => redirectTo(idPageOu)}
            on:keydown={() => redirectTo(idPageOu)}>
            {#if $english}
                {nameENPageOu}
            {:else}
                {nameFRPageOu}
            {/if}
        </li>
        <li class="navigation__ul__li"
            class:navigation__ul__li--active={selectedLink === idPageProjets && !$minitel}
            class:navigation__ul__li__minitel={$minitel}
            class:navigation__ul__li__minitel--active={selectedLink === idPageProjets && $minitel}
            on:click={() => redirectTo(idPageProjets)}
            on:keydown={() => redirectTo(idPageProjets)}>
            {#if $english}
                {nameENPageProjets}
            {:else}
                {nameFRPageProjets}
            {/if}
        </li>
    </ul>
</nav>
